import { Box, Button, FormField, Input } from "@wix/design-system";
import React, { useContext, useRef, useState } from "react";
import { EMBED_TYPE } from "./../../ricos-content/index.js";
import {
  EditorContext,
  ModalServiceContext,
  PluginsEventsContext,
  RicosContext
} from "./../../ricos-context/index.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { containsUrl } from "./../../_shared/link/contains-url.js";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common/index.js";
import { Panel, PanelHeader } from "./../../ui-components/index.js";
import { socialModals } from "../consts.js";
import {
  SOCIAL_EMBED_MODAL,
  SOCIAL_EMBED_MODAL_INPUT,
  SOCIAL_EMBED_MODAL_SUBMIT_BTN
} from "../data-hooks.js";
import { EMBED_DEFAULTS } from "../defaults.js";
import classes from "../statics/styles/insert-modal-scss.js";
import { LINK_PREVIEW_TYPE } from "../types.js";
const InsertModal = ({
  componentData,
  fetchData,
  nodeId,
  socialType
}) => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const modalService = useContext(ModalServiceContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const logBi = useBiNext({
    pluginId: "linkPreview",
    modalId: socialModals[socialType.toLowerCase()],
    nodeId
  });
  const [url, setUrl] = useState("");
  const [submittedInvalidUrl, setSubmittedInvalidUrl] = useState(false);
  const inputRef = useRef(null);
  const pluginEvents = {
    onPluginsPopOverClick: (data) => pluginsEvents.publishPluginPopoverClick(data)
  };
  const closeModal = () => {
    setSubmittedInvalidUrl(false);
    modalService.closeModal(
      socialModals[socialType.toLowerCase()]
    );
  };
  const onConfirm = (embedData) => {
    const publicCommands = getPublicCommands();
    if (nodeId) {
      publicCommands?.setBlock(nodeId, EMBED_TYPE, embedData);
    } else {
      publicCommands?.insertBlockWithBlankLines(EMBED_TYPE, embedData);
    }
  };
  const handleOnConfirm = async () => {
    pluginEvents?.onPluginsPopOverClick?.({
      pluginId: LINK_PREVIEW_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
    });
    logBi({ dataHook: SOCIAL_EMBED_MODAL_SUBMIT_BTN });
    if (url) {
      try {
        const { html } = await fetchData?.(url) || {};
        if (!html) {
          setSubmittedInvalidUrl(true);
          inputRef.current?.focus();
          return;
        }
        onConfirm({
          ...componentData,
          ...EMBED_DEFAULTS,
          src: url,
          oembed: {
            type: "rich",
            html
          }
        });
        closeModal();
      } catch {
        setSubmittedInvalidUrl(true);
        inputRef.current?.focus();
      }
    } else {
      setSubmittedInvalidUrl(true);
      inputRef.current?.focus();
    }
  };
  const onCloseRequested = () => {
    pluginEvents?.onPluginsPopOverClick?.({
      pluginId: LINK_PREVIEW_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.cancel
    });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(
    Panel,
    {
      closeButtonProps: { onClick: onCloseRequested },
      dataHook: SOCIAL_EMBED_MODAL,
      height: "fit-content"
    },
    /* @__PURE__ */ React.createElement(PanelHeader, { title: t(`EmbedURL_Social_${socialType}_Header_Title`) }),
    /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3", padding: "SP3" }, /* @__PURE__ */ React.createElement(
      FormField,
      {
        label: t(`EmbedURL_Social_${socialType}_Title`),
        maxLines: 2,
        status: submittedInvalidUrl ? "error" : void 0,
        statusMessage: submittedInvalidUrl ? t("SoundCloudUploadModal_Input_InvalidUrl") : void 0
      },
      /* @__PURE__ */ React.createElement(
        Input,
        {
          inputRef: (ref) => {
            inputRef.current = ref;
          },
          className: classes.input,
          type: "url",
          id: "dropdown-text-input",
          autocomplete: "off",
          textOverflow: "ellipsis",
          value: url,
          dataHook: SOCIAL_EMBED_MODAL_INPUT,
          onChange: (e) => {
            setSubmittedInvalidUrl(false);
            logBi({ dataHook: SOCIAL_EMBED_MODAL_INPUT, value: e.target.value });
            setUrl(e.target.value);
          },
          placeholder: t(`EmbedURL_Social_${socialType}_Placeholder`),
          onBlur: () => {
            if (url && !containsUrl(url)) {
              setSubmittedInvalidUrl(true);
            }
          },
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              handleOnConfirm();
            }
          }
        }
      )
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        dataHook: SOCIAL_EMBED_MODAL_SUBMIT_BTN,
        onClick: () => {
          handleOnConfirm();
        },
        size: "small"
      },
      t("Embed_Add_Button_Label")
    ))
  );
};
export {
  InsertModal
};
//# sourceMappingURL=InsertModal.js.map
